export const xx = [
  {
    name: '闽教学习',
    mark: 'mjyy',
    press: '福建教育出版社',
    business_id: 1,
    app_id: 1072051830,
    ios_schema: 'minjiaoenglish',
    android_schema: 'com.zhl.fep.aphone',
    education_record_number: '1100861'
  },
  {
    name: '冀教学习',
    mark: 'jjyy',
    press: '河北教育出版社',
    business_id: 7,
    app_id: 1268239103,
    ios_schema: 'jijiaoenglish',
    android_schema: 'com.zhl.jjyy.aphone',
    education_record_number: '1100849'
  },
  {
    name: '浙教学习',
    mark: 'zjyy',
    press: '浙江教育出版社',
    business_id: 11,
    app_id: 1395169128,
    ios_schema: 'zhejiaoenglish',
    android_schema: 'com.zhl.zjyy.aphone',
    education_record_number: '1100825'
  },
  {
    name: '赣教学习',
    mark: 'gjyy',
    new_mark: 'gjxx',
    press: '江西教育出版社',
    business_id: 12,
    app_id: 1434045734,
    ios_schema: 'ganjiaoenglish',
    android_schema: 'com.zhl.gjyy.aphone',
    education_record_number: '1100823'
  },
  {
    name: '桂教学习',
    mark: 'guijiaoxx',
    new_mark: 'guijxx',
    press: '广西教育出版社',
    business_id: 26,
    app_id: 1500228182,
    ios_schema: 'guijiaoenglish',
    android_schema: 'com.zhl.guijiaoxx.aphone',
    education_record_number: ''
  },
  {
    name: '孩有为',
    mark: 'hyw',
    press: '',
    business_id: 101,
    app_id: 1346374923,
    ios_schema: 'pac',
    android_schema: 'com.zhl.hyw.aphone',
    education_record_number: '1100863'
  },
  {
    name: '海教学习',
    mark: 'haijiaoxx',
    press: '海南出版社',
    business_id: 30,
    app_id: 1513306370,
    ios_schema: 'haijiaoxuexienglish',
    android_schema: 'com.zhl.haijiaoxx.aphone',
    education_record_number: ''
  },
  {
    name: '海燕英语',
    mark: 'hyyy',
    press: '海燕出版社',
    business_id: 15,
    app_id: 1447842886,
    ios_schema: 'haiyanenglish',
    android_schema: 'com.zhl.hyyy.aphone',
    education_record_number: '1100843'
  },
  {
    name: '黔教学习',
    mark: 'qjxx',
    press: '贵州教育出版社',
    business_id: 28,
    app_id: 1508431528,
    ios_schema: 'qianjiaoxuexienglish',
    android_schema: 'com.zhl.qjxx.aphone',
    education_record_number: ''
  },
  {
    name: '湖北教育',
    mark: 'hbxx',
    new_mark: 'hbjy',
    press: '湖北教育出版社',
    business_id: 19,
    app_id: 1492013768,
    ios_schema: 'hubeienglish',
    android_schema: 'com.zhl.hbxx.aphone',
    education_record_number: '1100851'
  },
  {
    name: '沪教学习',
    mark: 'hjxx',
    press: '上海教育出版社有限公司',
    business_id: 24,
    app_id: 1499780020,
    ios_schema: 'hujiaoenglish',
    android_schema: 'com.zhl.hjxx.aphone',
    education_record_number: ''
  },
  {
    name: '吉教乐学',
    mark: 'jilinxx',
    new_mark: 'jjlx',
    press: '吉林教育出版社',
    business_id: 20,
    app_id: 1489709120,
    ios_schema: 'jilinenglish',
    android_schema: 'com.zhl.jilinxx.aphone',
    education_record_number: '1100853'
  },
  {
    name: '桂师学习',
    mark: 'gsxx',
    press: '广西师范大学出版社集团有限公司',
    business_id: 27,
    app_id: 1506862226,
    ios_schema: 'guishienglish',
    android_schema: 'com.zhl.gsxx.aphone',
    education_record_number: ''
  },
  {
    name: '接力学习',
    mark: 'jlyy',
    press: '接力出版社',
    business_id: 9,
    app_id: 1272612907,
    ios_schema: 'jielienglish',
    android_schema: 'com.zhl.jlyy.aphone',
    education_record_number: '1100859'
  },
  {
    name: '京师学习',
    mark: 'jsyy',
    press: '北京师范大学出版社',
    business_id: 6,
    app_id: 1268248648,
    ios_schema: 'jingshienglish',
    android_schema: 'com.zhl.jsyy.aphone',
    education_record_number: '1100839'
  },
  {
    name: '辽海学习',
    mark: 'lhxx',
    press: '辽海教育出版社',
    business_id: 23,
    app_id: 1495011634,
    ios_schema: 'lhenglish',
    android_schema: 'com.zhl.lhxx.aphone',
    education_record_number: ''
  },
  {
    name: '龙教学习',
    mark: 'hljxx',
    new_mark: 'longjxx',
    press: '黑龙江教育出版社',
    business_id: 21,
    app_id: 1492013827,
    ios_schema: 'longjiaoenglish',
    android_schema: 'com.zhl.hljxx.aphone',
    education_record_number: '1100847'
  },
  {
    name: '鲁教学习',
    mark: 'ljyy',
    press: '山东教育出版社',
    business_id: 13,
    app_id: 1414197771,
    ios_schema: 'lujiaoenglish',
    android_schema: 'com.zhl.ljyy.aphone',
    education_record_number: '1100869'
  },
  {
    name: '陕旅学习',
    mark: 'slyy',
    press: '陕旅出版社',
    business_id: 2,
    app_id: 1186134815,
    ios_schema: 'shanlvenglish',
    android_schema: 'com.zhl.english.aphone',
    education_record_number: '1100817'
  },
  {
    name: '时代学习',
    mark: 'asyy',
    new_mark: 'sdxx',
    press: '安徽少年儿童出版社',
    business_id: 8,
    app_id: 1267786844,
    ios_schema: 'anshaoenglish',
    android_schema: 'com.zhl.asyy.aphone',
    education_record_number: '1100821'
  },
  {
    name: '苏科优学',
    mark: 'skxx',
    new_mark: 'skyx',
    press: '江苏科学技术出版社',
    business_id: 29,
    app_id: 1508498836,
    ios_schema: 'sukeyouxueenglish',
    android_schema: 'com.zhl.skxx.aphone',
    education_record_number: ''
  },
  {
    name: '川教学习',
    mark: 'cjyy',
    press: '四川教育出版社',
    business_id: 14,
    app_id: 1434042844,
    ios_schema: 'chuanjiaoenglish',
    android_schema: 'com.zhl.cjyy.aphone',
    education_record_number: ''
  },
  {
    name: '湘少学习',
    mark: 'xsyy',
    press: '湖南少年儿童出版社',
    business_id: 4,
    app_id: 1225815327,
    ios_schema: 'xiangshaoenglish',
    android_schema: 'com.zhl.xsyy.aphone',
    education_record_number: '1100833'
  },
  {
    name: '优化学习',
    mark: 'yhxx',
    press: '世纪天鸿出版社',
    business_id: 16,
    app_id: 1457659415,
    ios_schema: 'youhuaxuexi',
    android_schema: 'com.zhl.yhxx.aphone',
    education_record_number: '1100855'
  },
  {
    name: '渝快学',
    mark: 'yujiaoxx',
    new_mark: 'yujxx',
    press: '重庆出版集团',
    business_id: 25,
    app_id: 1500227957,
    ios_schema: 'yujiaoenglish',
    android_schema: 'com.zhl.yujiaoxx.aphone',
    education_record_number: '1101737'
  },
  {
    name: '粤人学习',
    mark: 'yryy',
    press: '广东人民出版社',
    business_id: 3,
    app_id: 1218259812,
    ios_schema: 'yuerenenglish',
    android_schema: 'com.zhl.yryy.aphone',
    education_record_number: '1100867'
  },
  {
    name: '云教学习',
    mark: 'yjyy',
    new_mark: 'yjxx',
    press: '云南教育出版社',
    business_id: 18,
    app_id: 1472177319,
    ios_schema: 'yunjiaoenglish',
    android_schema: 'com.zhl.yjyy.aphone',
    education_record_number: '1100865'
  },
  {
    name: '长少学习',
    mark: 'csyy',
    press: '长江少儿出版社',
    business_id: 5,
    app_id: 1434042844,
    ios_schema: 'changshaoenglish',
    android_schema: 'com.zhl.csyy.aphone',
    education_record_number: '1100841'
  },
  {
    name: '华教学习',
    mark: 'huajiaoxx',
    new_mark: 'huajxx',
    press: '华语教学出版社',
    business_id: 33,
    app_id: 1111275195,
    ios_schema: 'huajiaoeng',
    android_schema: 'com.zhl.huajiaoxx.aphone',
    education_record_number: ''
  },
  {
    name: '凤凰智慧帮',
    mark: 'fhxx',
    new_mark: 'fenghzhb',
    press: '江苏凤凰教育出版社',
    business_id: 34,
    app_id: 1111397306,
    ios_schema: 'fheng',
    android_schema: 'com.zhl.fhxx.aphone',
    education_record_number: ''
  }
]